import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
const useClasses = makeStyles()((theme) => ({
  layoutDetailsBlock: {
    margin: theme.spacing(0, 4, 4)
  },
  layoutDetailsBlockHeader: {
    margin: theme.spacing(3, 0, 2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  layoutDetailsBlockToolbar: {
    marginBottom: theme.spacing(2.5)
  }
}));
const LayoutDetailsBlock = ({ content, headerActions, toolbar, title }) => {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(Box, { className: classes.layoutDetailsBlock }, /* @__PURE__ */ React.createElement("div", { className: classes.layoutDetailsBlockHeader }, /* @__PURE__ */ React.createElement(Typography, { variant: "h6" }, /* @__PURE__ */ React.createElement(LocalizedText, { label: title })), headerActions), /* @__PURE__ */ React.createElement(Box, { className: classes.layoutDetailsBlockToolbar }, toolbar), content);
};
export {
  LayoutDetailsBlock
};
//# sourceMappingURL=LayoutDetailsBlock.js.map
